import { DatePipe }            from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { DateParserService } from '../../../app-lite/core/services/date-parser.service';

@Pipe({
  name: 'globalDate'
})
export class GlobalDatePipe implements PipeTransform {
  constructor (
    private datePipe         : DatePipe,
    private dateParserService: DateParserService
  ) {}

  transform ( date : string ) : string {
    const format = this.dateParserService.getFormat(true);

    return this.datePipe.transform(date, format);
  }
}
